import { createAsyncThunk } from '@reduxjs/toolkit';
import { SUPERADMIN_URLS } from '@custom/Utils/constants/apiUrls';

const getSuperadminDetailsApi = createAsyncThunk('getSuperadminDetailsApi', async () => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = `${SUPERADMIN_URLS.getSuperadminDetails}`
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default getSuperadminDetailsApi;
